export default {"src":"/_next/static/media/sequencing-mini.dbaa4af2.svg","height":24,"width":24};